import { FC, useMemo } from 'react';
import { beautifyTheLowHighObject } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { getTotalSalesAmountPredict } from './format';
import styles from './index.module.less';

const TotalSalesAmountPredict: FC<{
  category1SalesAmountPredict?: number | null;
  category2SalesAmountPredict?: number | null;
}> = ({
  category1SalesAmountPredict,
  category2SalesAmountPredict,
}) => {
  const methods = useMethods({
    formatTotalSalesAmount(category1SalesAmount, category2SalesAmount) {
      const totalSalesAmount = getTotalSalesAmountPredict(category1SalesAmount, category2SalesAmount);
      return beautifyTheLowHighObject(1, totalSalesAmount, 2, { low: '元', high: '万元', top: '亿元' });
    }
  });

  const totalSalesAmount = useMemo(() => {
    return methods.formatTotalSalesAmount(category1SalesAmountPredict, category2SalesAmountPredict);
  }, [category1SalesAmountPredict, category2SalesAmountPredict]);

  return (
    <div className={styles.totalSalesAmountPredict}>
      <div className={styles.title}>总营业额预估</div>
      <div className={styles.valueRow}>
        <div className={styles.value}>{totalSalesAmount.val}</div>
        <div className={styles.unit}>{totalSalesAmount.unit}</div>
      </div>
    </div>
  );
};

export default TotalSalesAmountPredict;
